import i18n from '@/../i18n';
import { DoubleOptInPageTypeEnum } from './types';

export const pageTypeOptions = () => [
    {
        label: i18n.t('defaultpage'),
        value: DoubleOptInPageTypeEnum.Defaultpage,
    },
    {
        label: i18n.t('landingpage'),
        value: DoubleOptInPageTypeEnum.Landingpage,
    },
    {
        label: i18n.t('externalwebsite'),
        value: DoubleOptInPageTypeEnum.Externalwebsite,
    },
];
